import React, { useState, useCallback } from 'react'
import styled from 'styled-components'

import CancelSubscriptionModal from 'pages/HehmDevice/CancelSubscriptionModal'

import { Button, type ButtonStyles } from '@nexiahome/ui-common/components/primitives/buttons'

import { Panel } from 'components/Panel'

import { useSessionContext } from 'hooks/SessionContext'

import Api from 'services/api'

import { longDateTime } from 'helpers/formatters'
import { ButtonContainer, screenSize } from 'styles/shared'

import { DeviceBase } from 'types/Device'

type props = {
  device: DeviceBase | undefined
  refreshPageCallback?: () => void | null | undefined
}

const AssignedSystemTime = ({ device, refreshPageCallback }: props) => {
  const [deleteInProgress, setDeleteInProgress] = useState(false)
  const [showCancelSubscriptionModal, setShowCancelSubscriptionModal] = useState(false)
  const { session } = useSessionContext()

  const onCancelSubscription = useCallback(
    async (dealerId: string, deviceId: string, reason: string) => {
      setDeleteInProgress(true)

      await Api.HomeHealth.deprovisionDevice(dealerId, deviceId, reason)
        .then(() => {
          refreshPageCallback && refreshPageCallback()
        })
        .finally(() => setDeleteInProgress(false))
    },
    [refreshPageCallback]
  )

  return (
    <S.Panel>
      {!session.isFsr && device && (
        <S.AssignedSystemTime>
          <span>Dealer assigned this system to the customer in Diagnostics on: {longDateTime(device.createdAt)}</span>

          <S.ButtonContainer>
            {session.isDealerAdmin && <Button decoration="danger" text="Cancel Subscription" enabled={!deleteInProgress} styles={buttonStyle} onPress={() => setShowCancelSubscriptionModal(true)} /> }
          </S.ButtonContainer>
        </S.AssignedSystemTime>
      )}

      {device && (
        <CancelSubscriptionModal
          isVisible={showCancelSubscriptionModal}
          closeCallback={() => setShowCancelSubscriptionModal(false)}
          deviceId={device.deviceId}
          onCancelCallback={(reason) => onCancelSubscription(session.dealerId, device.deviceId, reason)}
        />
      )}
    </S.Panel>
  )
}

const buttonStyle: ButtonStyles = {
  text: {
    textAlign: 'center'
  }
}

export default AssignedSystemTime

const S = {
  Panel: styled(Panel)`
    border-bottom: 0;
    padding: 5px 0px;

    @media ${screenSize.small} {
      padding: 5px 10px;
    }
  `,
  AssignedSystemTime: styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media ${screenSize.small} {
      justify-content: center;
      flex-direction: column;
    }
  `,
  ButtonContainer: styled(ButtonContainer)`
    margin: 0px;
    padding: 0px;
    border: none;

    & > button {
      margin: 0 !important;
      height: 34px !important;
      min-width: 64px !important;
   }
  `
}
